module.exports = "/_next/static/images/06-810e94ef9a8e35664497ba7c0ef7567f.png";